export type PieceType = 'p' | 'n' | 'b' | 'r' | 'q' | 'k' | 'm' | 'x';

export type PartKind = 'box' | 'sphere' | 'cone' | 'cylinder';

export interface PiecePart {
  readonly kind: PartKind;
  readonly args: [number, number, number];
  readonly pos: [number, number, number];
  readonly scale?: [number, number, number];
}

/**
 * Low-poly placeholder pieces built from primitives (aod vibe; AI-gen themed
 * skins replace these in M4). Base of each piece sits at y=0.
 */
export const PIECE_PARTS: Record<PieceType, readonly PiecePart[]> = {
  p: [
    { kind: 'cylinder', args: [0.22, 0.22, 0.16], pos: [0, 0.08, 0] },
    { kind: 'cylinder', args: [0.14, 0.16, 0.2], pos: [0, 0.26, 0] },
    { kind: 'sphere', args: [0.15, 0.15, 0.15], pos: [0, 0.48, 0] },
    { kind: 'cone', args: [0.07, 0.12, 8], pos: [0, 0.63, 0] },
  ],
  n: [
    { kind: 'cylinder', args: [0.26, 0.26, 0.1], pos: [0, 0.05, 0] },
    { kind: 'box', args: [0.2, 0.5, 0.16], pos: [0, 0.36, 0] },
    { kind: 'box', args: [0.12, 0.14, 0.2], pos: [0, 0.66, 0.12] },
  ],
  b: [
    { kind: 'cylinder', args: [0.26, 0.26, 0.1], pos: [0, 0.05, 0] },
    { kind: 'cone', args: [0.22, 0.55, 8], pos: [0, 0.42, 0] },
    { kind: 'sphere', args: [0.13, 0.13, 0.13], pos: [0, 0.76, 0] },
    { kind: 'cone', args: [0.05, 0.12, 8], pos: [0, 0.9, 0] },
  ],
  r: [
    { kind: 'cylinder', args: [0.28, 0.28, 0.12], pos: [0, 0.06, 0] },
    { kind: 'cylinder', args: [0.2, 0.22, 0.42], pos: [0, 0.36, 0] },
    { kind: 'box', args: [0.3, 0.1, 0.08], pos: [0, 0.6, 0.1] },
    { kind: 'box', args: [0.3, 0.1, 0.08], pos: [0, 0.6, -0.1] },
    { kind: 'box', args: [0.08, 0.1, 0.3], pos: [0.1, 0.6, 0] },
    { kind: 'box', args: [0.08, 0.1, 0.3], pos: [-0.1, 0.6, 0] },
  ],
  q: [
    { kind: 'cylinder', args: [0.28, 0.28, 0.12], pos: [0, 0.06, 0] },
    { kind: 'cylinder', args: [0.2, 0.22, 0.24], pos: [0, 0.28, 0] },
    { kind: 'cylinder', args: [0.16, 0.18, 0.24], pos: [0, 0.52, 0] },
    { kind: 'sphere', args: [0.16, 0.16, 0.16], pos: [0, 0.78, 0] },
    { kind: 'cone', args: [0.05, 0.12, 8], pos: [0, 0.92, 0] },
  ],
  k: [
    { kind: 'cylinder', args: [0.28, 0.28, 0.12], pos: [0, 0.06, 0] },
    { kind: 'cylinder', args: [0.2, 0.22, 0.24], pos: [0, 0.28, 0] },
    { kind: 'cylinder', args: [0.16, 0.18, 0.26], pos: [0, 0.54, 0] },
    { kind: 'box', args: [0.3, 0.06, 0.06], pos: [0, 0.76, 0] },
    { kind: 'box', args: [0.06, 0.06, 0.3], pos: [0, 0.76, 0] },
    { kind: 'box', args: [0.06, 0.14, 0.06], pos: [0, 0.86, 0] },
  ],
  m: [
    { kind: 'cylinder', args: [0.3, 0.3, 0.16], pos: [0, 0.08, 0] },
    { kind: 'cylinder', args: [0.2, 0.24, 0.1], pos: [0, 0.22, 0] },
  ],
  x: [
    { kind: 'cylinder', args: [0.3, 0.3, 0.16], pos: [0, 0.08, 0] },
    { kind: 'cylinder', args: [0.2, 0.24, 0.1], pos: [0, 0.22, 0] },
    { kind: 'cylinder', args: [0.16, 0.18, 0.12], pos: [0, 0.34, 0] },
    { kind: 'cylinder', args: [0.12, 0.14, 0.1], pos: [0, 0.45, 0] },
  ],
};

export function pieceTypeOf(char: string): PieceType {
  return char.toLowerCase() as PieceType;
}

export function isWhitePiece(char: string): boolean {
  return char === char.toUpperCase();
}
